import { getSessionInfo } from "@biPoint/sessionId";
import { useRoute } from "vue-router";
import { pageType } from "@biPoint/_configOfficialGuide";
import { getDuration } from "@utiles/index";
export default function usePointViewPage({
  pageKey,
  moduleName,
  isAutoSendViewPage = true,
}) {
  const route = useRoute();
  let startTime = new Date();

  let homeViewStore = [];
  let articleListViewStore = {};

  // 文章列表、文章详情手动调用，其他页面自动调用
  const sendViewPagePoint = (id?: string | number, manualSource?: string) => {
    const source = route.query.source as string;
    const sessionInfo = getSessionInfo();
    const sid = sessionInfo?.sid || "";
    if (!sid) return;
    const viewPageParams = {
      pageKey: pageKey || "",
      pageSourceKey: source || "",
      id: id || "",
      moduleName: moduleName || "",
    };

    switch (pageKey) {
      case pageType.homePage: {
        if (!homeViewStore.includes(sid)) {
          viewPagePoint(viewPageParams);
          homeViewStore.push(sid);
        }
        break;
      }
      case pageType.articleListPage: {
        if (articleListViewStore?.[sid]?.includes(id)) {
          break;
        }
        viewPageParams.pageSourceKey = manualSource || source || "";
        if (!articleListViewStore[sid]) {
          articleListViewStore[sid] = [];
          articleListViewStore[sid].push(id);
          viewPagePoint(viewPageParams);
          break;
        }
        if (
          articleListViewStore[sid] &&
          !articleListViewStore[sid].includes(id)
        ) {
          articleListViewStore[sid].push(id);
          viewPagePoint(viewPageParams);
          break;
        }
        break;
      }
      case pageType.articleDetailPage:
      case pageType.searchPage: {
        viewPagePoint(viewPageParams);
        break;
      }
    }
  };

  onActivated(() => {
    startTime = new Date();
    if (isAutoSendViewPage) {
      sendViewPagePoint();
    }
  });

  onDeactivated(() => {
    const duration = getDuration(startTime);
    // 上报时长信息
    window.officialGuideDataLayer.push({
      eventName: "stay_time",
      eventType: moduleName,
      eventValue: {
        duration: duration,
      },
    });
  });

  return {
    sendViewPagePoint,
  };
}
